module.exports = __webpack_public_path__ + "img/legend.12d01494.png";